import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Fulfillment, DeliveryPlan } from 'services/action';

import { Page, Button } from 'ui/components';

import {
  InformationPlan,
} from './component/section';

import { FormInput, FormItems } from './component/form';

const initialState = {
  plan: null,
  form: null,
  items: [],
};

const CreateScreen = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const [{ form, items, plan }, setState] = React.useState(initialState);

  const $onLoadPlan = async (id) => {
    const req = await Dispatch(DeliveryPlan.$show(id));

    if (req?.message === 'success') {
       setState((prevState) => ({...prevState, plan: req?.data}));
    }
  }

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleItemsChange = (v) => {
    setState((prevState) => ({ ...prevState, items: v }));
  };

  const $handleSubmit = async () => {
    const payload = {
      plan_id: plan?.id,
      note: form?.note,
      ...items,
    };

    const submit = await Dispatch(Fulfillment.$create(payload));

    if (submit?.message === 'success') {
      History.replace(`/delivery/fulfillment/${submit?.data?.id}`);
    }
  };

  React.useEffect(() => {
    if (!location?.state?.plan) {
        History.push('/delivery/plan');
    };
    $onLoadPlan(location?.state?.plan);
  }, [location?.state?.plan]);

  return (
    <Page type="form" className=" bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Buat Fulfillment" />

      <Page.Body className="d-block px-3">
        <div className='row'>
            <div className='col-md-8 col-12'>
              <InformationPlan data={plan} created />
            </div>
            <div className='col-md-4 col-12'>
              <FormInput onInputChange={$handleFormChange} />
            </div>
        </div>
        <FormItems plan={plan} onInputChange={$handleItemsChange}/>

      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/delivery/fulfillment`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;